<script setup lang="ts">
import { type PropType } from 'vue';
import { popoverProps, type GlobalThemeOverrides, type PopoverTrigger } from 'naive-ui';

const props = defineProps({
  ...popoverProps,
  // Gaia panels open on click, not hover.
  trigger: {
    type: String as PropType<PopoverTrigger>,
    default: 'click',
  },
  // Gaia has no arrowed popovers: panels are anchored, not tethered.
  showArrow: {
    type: Boolean,
    default: false,
  },
  /**
   * `raw` hands the panel its own surface, so the content decides its border,
   * radius and shadow — the settings panel from mock 5a is 352px with a ring
   * shadow that naive's popover chrome can't express.
   */
  raw: {
    type: Boolean,
    default: true,
  },
  /**
   * `raw` drops naive's background and radius but keeps its box-shadow, and
   * that shadow is drawn on the square body wrapping our rounded surface — so
   * outside each rounded corner sits an unshadowed notch, reading as a pale
   * flake against the shadow around it. The content owns the shadow too.
   */
  themeOverrides: {
    type: Object as PropType<GlobalThemeOverrides['Popover']>,
    default: () => ({ boxShadow: 'none' }),
  },
});
</script>

<template>
  <n-popover v-bind="props">
    <template #trigger>
      <slot name="trigger" />
    </template>
    <slot />
  </n-popover>
</template>
